export default function($element) {
    if (!$element.hydrationState) {
        $element.hydrationState = {
            onInteraction: 0,
            onGlobalEvent: 0,
            hydrationQueue: [],
            blockersCreated: 0
        }
    }
}